export const TIPSTER_REQUEST = 'tipsterRequest';
export const TIPSTER_FAILURE = 'tipsterFailure';
export const TIPSTER_SUCCESS = 'tipsterSuccess';
